import { render, staticRenderFns } from "./TaskCategoryIcon.vue?vue&type=template&id=7e024664"
import script from "./TaskCategoryIcon.vue?vue&type=script&lang=js"
export * from "./TaskCategoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports